/**
 * Questa è la classe per il Repository che riguarda il riepilogo, quindi il calcolo dei costi
 * Quindi tutte le richieste ai servizi che c'entrano con il riepilogo andrebbe messa qui
 *
 */

import axios, { AxiosResponse } from "axios";
import axiosRetry from "axios-retry";
import { IBaseRequest, IBaseResponse } from "core/interfaces/data/Base";

import {
	ICalcolaTariffaResponse,
	ICalcolaTariffaRequest,	
	IOperatorAvailabilitySetAllocatedRequest,
	ITariffa,
} from "core/interfaces/data/IDataPreventivoRequest";

// questo serve per fare la richiesta una seconda volta se in caso la prima non va a buon fine
axiosRetry(axios, {
	retries: 2,
});

// serve per settare i cookie in risposta
axios.defaults.withCredentials = true;

class DataPreventivoRepository {
	/**
	 * Metodo che ritorna la tariffa calcolata
	 * Le props, ovvero i parametri che servono per fare la richiesta li dichiaro
	 * con una interfaccia che contiene i campi che servono per chiamare il servizio
	 * Nella richiesta di Axios gli do il tipo così puoi usare l'intellisense
	 * Rispetto ai dati che hai messo nella Response crei l'interfaccia che mappa quei campi
	 */
	async calcolaTariffa(props: ICalcolaTariffaRequest) {
		try {
			const url = `${window.CONFIG.REACT_APP_WS_HSB}/AmountActivityTariffed`;

			const res = await axios.post<ICalcolaTariffaRequest, AxiosResponse<ICalcolaTariffaResponse>>(url, props);

			if (res.data.Errors) {
				throw new Error(JSON.stringify(res.data.Errors));
			}

			const tariffa: ITariffa = {
				IdTariffa: res.data.IdTariffa,
				ImportoTariffaConIva: res.data.ImportoTariffaConIva,
				ImportoTariffa: res.data.ImportoTariffa,
				IdCausaleIva: res.data.IdCausaleIva,
				Iva: res.data.Iva,
			};

			return tariffa;
		} catch (err) {
			console.log(err);
		}
	}

	async bloccaDisponibilita(props: IOperatorAvailabilitySetAllocatedRequest) {
		try {
			const url = `${window.CONFIG.REACT_APP_WS_HSB}/OperatorAvailabilitySetAllocated`;

			const res = await axios.post<IOperatorAvailabilitySetAllocatedRequest, AxiosResponse<IBaseResponse>>(url, props);

			if (res.data.Errors) {
				throw new Error(JSON.stringify(res.data.Errors));
			}

			return res.data.Result;
		} catch (err) {
			console.log(err);
			return false;
		}
	}

	async resetDisponibilita(props: IBaseRequest) {
		try {
			const url = `${window.CONFIG.REACT_APP_WS_HSB}/OperatorAvailabilityResetAllocated`;

			const res = await axios.post<IBaseRequest, AxiosResponse<IBaseResponse>>(url, props);

			if (res.data.Errors) {
				throw new Error(JSON.stringify(res.data.Errors));
			}

			return res.data.Result;
		} catch (err) {
			console.log(err);
			return false;
		}
	}
}
var DataPreventivoRep=new DataPreventivoRepository()
export default DataPreventivoRep;
